import { VFC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportChainalysisAddressScreening } from 'dashboard/models/report/integration/chainalysis-address-screening';

interface ChainalysisAddressScreeningProps {
  report: ReportChainalysisAddressScreening;
  isRedacted: boolean;
}

const ChainalysisAddressScreening: VFC<ChainalysisAddressScreeningProps> = ({
  report,
  isRedacted,
}: ChainalysisAddressScreeningProps) => {
  return (
    <AttributeGrid>
      <AttributeItem
        title='Address'
        value={report.attributes.query?.address}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-chainalysis-address-screening_address'
      />
    </AttributeGrid>
  );
};

export default ChainalysisAddressScreening;
